import i18n from 'i18next'
import { useState } from 'react'
import { initReactI18next } from 'react-i18next'
import { setYupLocale } from 'config/validationMessage'
import en from 'locales/en.json'
import ja from 'locales/ja.json'

const resources = {
  en: {
    translation: en,
  },
  ja: {
    translation: ja,
  },
}

const languages = [
  { value: 'ja', title: '日本語' },
  { value: 'en', title: 'English' },
]

export const isLocalStorageAvailable = () => {
  if (typeof localStorage === 'undefined') {
    console.log('localStorage is not available')
    return false
  }
  try {
    localStorage.setItem('yq-test', 'test')
    localStorage.removeItem('yq-test')
    return true
  } catch (e) {
    console.log('localStorage is not available')
    return false
  }
}

const initLanguage = isLocalStorageAvailable()
  ? localStorage.getItem('language') || i18n.language
  : i18n.language

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initLanguage,
    fallbackLng: 'ja',
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: false,
  })
  .then(() => {
    setYupLocale()
  })

export const useLanguage = () => {
  const [language, setLanguage] = useState(initLanguage || i18n.language)

  function handleChange(lng?: string) {
    const l = lng || i18n.language
    i18n.changeLanguage(l)
    if (isLocalStorageAvailable()) {
      localStorage.setItem('language', l)
    }
    setLanguage(l)
    setYupLocale()
  }

  return {
    language,
    languages,
    setLanguage: handleChange,
  }
}

export default i18n
